
export function getQueryStringForMultiselect (values, options) {   
    let arrayAsStringWithQutes = options.skipQuotes ? values.join(",") : "'" + values.join("','") + "'";
    let queryString =
        "(" +
        options.parameter +
        options.operator +
        " IN (" +
        arrayAsStringWithQutes +
        ")" +
        ")";
    return queryString;
}

export function getQueryStringForMultiselectUsingLikeOperator (values, options) {
    let queryString = '';
    values.forEach(function (selectedValue) {
        if (queryString !== '') {
            queryString = queryString + " OR ";
        }
        queryString = queryString + "(" +
            options.parameter + options.operator +
            " LIKE '%" +
            (options.filterProperty ? selectedValue[options.filterProperty] : selectedValue) +
            "%')";
    });
    queryString = '(' + queryString + ')';
    return queryString;
}

export function getQueryStringForCheckbox (value, options) {
    if (!value) {
        return null;
    } else {
        let queryString =
            options.filterFieldName +
            " " +
            options.operator;
        if (options.stringCheck) {
            queryString = queryString + " '" + options.checked + "'";
        } else {
            queryString = queryString + " " + options.checked;
        }
        return queryString;
    }
}

export function getQueryStringForYearRange (fromYearValue, toYearValue, onlyIncludeTimeseriesThatCoverFullYearRange) {
    if (onlyIncludeTimeseriesThatCoverFullYearRange) {
        return "(dt_min_start_time <= DATE '" +
        fromYearValue +
        "-01-01'" +
        " AND (dt_max_end_time IS NULL OR dt_max_end_time >= DATE '" +
        toYearValue +
        "-12-31'))";
    } else {
        return "(dt_min_start_time <= DATE '" +
        toYearValue +
        "-12-31'" +
        " AND (dt_max_end_time IS NULL OR dt_max_end_time >= DATE '" +
        fromYearValue +
        "-01-01'))";
    }
    
}

export function getQueryStringForRange (fromToValues, options) {
    let queryString = "";

    if (options.mode === "range") {
        queryString =
          "((" +
          options.startParameter +
          " >= " +
          fromToValues[0] +
          " AND " +
          (options.endParameter || options.startParameter) +
          " <= " +
          fromToValues[1] +
          "))";

      } else {
        queryString =
          options.startParameter +
          " " +
          options.operator +
          " " +
          fromToValues[0];
      }

      if (options.isFeltEgenskap) {
        queryString = queryString + " AND feltNr IS NOT NULL";
      }

      return queryString;
}